//@ts-nocheck

import React, { useState, useEffect } from 'react'
import InfiniteScrollTable from '../../../../Table/InfiniteScrollTable'
import Icon from '../../../../Icon2/Icon'
import CreateFolder from '../CreateFolder';
import './index.css';
import styles from './index.module.css'
import { formatTime } from '../../../commons/util';
import usePermissions from '../../../hooks/usePermissions';

const iconFromType = (contentType) => {
  if (contentType.startsWith('image/')) return null
  else if (contentType.startsWith('application/')) return 'Group'
  else return 'File'
}
const FolderCreate = ({ editor, createFolder }) => {
  return (
    <div role="row" className="Table__body__row " data-testid="folder-create-wrapper" style={{ height: '60px', width: '100%' }}>
      <div role="cell" className="Table__body__column ">
        <div className="flex-v-center">
          <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
            <CreateFolder editor={editor} createFolder={createFolder} />
          </div>
        </div>
      </div>
      <div role="cell" className="Table__body__column "></div>
      <div role="cell" className="Table__body__column "></div>
    </div>
  )
}

const GetIcon = ({ data }) => {
  return (
    <React.Fragment>
      <span className={styles['list-icon']} style={{ background: `${data.url ? `url(${data.url})` : 'inherit'}` }}>
        {iconFromType(data.content_type) && <Icon size='medium' icon={iconFromType(data.content_type)} />}
      </span>
      {data.name ? data.name : data.filename}
    </React.Fragment>
  )
}

export const NoAssets = ({ length, children }) => {
  return length === 0 ? (
    <>
      <FolderCreate createFolder={createFolder} />
    </>
  ) : children
}

export const ListView = ({ t = (key: string) => '', assets, assetsCount, itemStatusMap, selectedAsset, users, createFolder, fetchOnChange, loadMore, handleClick, loading, editor, permissions, folderUid, minBatchSizeToFetch }) => {
  const { isCreateAllowed } = usePermissions(assets, folderUid, permissions);

  const columns = [
    {
      Header: 'Name',
      id: 'name',
      accessor: (data) => {
        return (
          <div className={'flex-v-center'}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <GetIcon data={data} />
            </div>
          </div>
        )
      },
      default: false,
      addToColumnSelector: true,
    },
    {
      Header: 'Unique Id',
      accessor: (data) => data.uid,
      default: false,
      addToColumnSelector: true,
      disableSortBy: true,
    },
    {
      Header: 'Last Modified By',
      accessor: (data) => <div className={'last-updated-by'}><span>{users?.[data?.updated_by] || 'Anonymous'}</span> <span className='last-updated-by-time'>{formatTime(data?.updated_at)}</span></div>,
      default: false,
      addToColumnSelector: true,
      disableSortBy: true,
    },
  ]

  if (assetsCount === 0 && isCreateAllowed) {
    return (
      <FolderCreate createFolder={createFolder} />
    )
  }

  return (
    <div style={{ height: '290px' }} data-testid="upload-list-view">
      <InfiniteScrollTable
        tableHeight={290}
        data={assets}
        columns={columns}
        uniqueKey={'uid'}
        fetchTableData={fetchOnChange}
        loadMoreItems={loadMore}
        isLoading={loading}
        staticRowCount={1}
        customRowAdd={true}
        customRowComponent={isCreateAllowed ? <FolderCreate editor={editor} createFolder={createFolder} /> : null}
        totalCounts={assetsCount}
        onRowClick={handleClick}
        singleSelectedRowId={selectedAsset.uid}
        itemStatusMap={itemStatusMap}
        columnSelector={false}
        minBatchSizeToFetch={minBatchSizeToFetch || 30}
        itemSize={60}
        name={{ singular: t('AssetPicker.asset') || 'Asset', plural: t('AssetPicker.assets') || 'Assets' }}
      />
    </div>
  )
}
